const datalayer = window.tc_vars;

/**
 * Analytics Product Page init
 */
export const init = () => {

  jQuery('body').on('click','.js-spare', e =>{
  // add internal campaign on spare parts link
    const linkSpareParts = cube.$('#collapse-services .js-spare');
    if (linkSpareParts) initSpareParts(linkSpareParts);
  });

};

/**
 * For a given <a> link, with 'href' attribute
 * Concatenate the necessary 'intcmp' parameters & details to the href URL
 * In order to track the click as an internal campaign
 * @param {DOM} link
 */
const initSpareParts = link => {
  // Exit if link already contains 'intcmp' params
  if (!link.href || link.href.indexOf('type=intcmp') > -1) return;

  // Get campaign parameters
  const intcmpVariant = datalayer.product_family || datalayer.page_cat4;
  const intcmpName = `spare-parts-${intcmpVariant.replace(/ /g, '-')}`;

  // Update 'href'
  link.href = `${link.href}&type=intcmp&intcmp=intcmp:${intcmpName}`;
};



// WEBPACK FOOTER //
// ./src/analytics/analytics-product-page.js